<form *ngIf="user" [formGroup]="form" class="mt-4">
  <div class="column">
    
    <div class="">
      <dx-text-box
        formControlName="currentPassword"
        [label]="'common.currentPassword' | translate | ucfirst"
        [(ngModel)]="oldPassword"
        mode="password" formField required
      />
    </div>
    
    <div class="">
      <dx-text-box
        formControlName="newPassword"
        [label]="'common.newPassword' | translate | ucfirst"
        [(ngModel)]="newPassword"
        mode="password" formField required minlength="8"
        pattern="^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9]).{6,}$"
        [attr.data-pattern-msg]="'errors.userPassword' | translate"
      />
    </div>
    
    <div class="">
      <dx-text-box
        formControlName="confirmPassword"
        [label]="'common.confirmPassword' | translate | ucfirst" 
        [(ngModel)]="confirmPassword"
        mode="password" formField required
      />
    </div>
    
    <div id="capsLockWarning" *ngIf="capsLock">
      <p>{{capsLockMessage}}</p>
    </div>

  </div>
  <div class="mt-3 text-right">
    <dx-button
      (onClick)="updateEntity()"
      type="default"
      icon="save"
      [text]="('common.save') | translate | ucfirst"
      [disabled]="!form.valid"
    ></dx-button>
  </div>
</form>  
 

